<div class="flex flex-column consult__section consult__treatment-plan">
  <div class="col-12 inline-flex flex-wrap consult__section-subheading-group">
    <h3 class="col-12 inline-flex align-items-center p-0 consult__section-subheading cursor-pointer"
      (click)="expandSection = !expandSection">
      <i class="fas" [style.fontSize.px]="12" [ngClass]="{
        'fa-minus': expandSection,
        'fa-plus': !expandSection
      }"></i>
      <label class="ml-2 mb-0 cursor-pointer" for="treatment-plan_{{turn}}">{{screen.heading}}</label>
    </h3>
  </div>

  <span class="col-12 px-0" *ngIf="expandSection">
    <textarea pInputTextarea name="treatment-plan_{{turn}}" [(ngModel)]="value" [rows]="4" validation
      [required]="!readonly" [readonly]="readonly" class="uppercase m-0" *ngIf="!readonly"></textarea>

    <span *ngIf="readonly">{{value}}</span>
  </span>
</div>